<template>
	<v-app-bar
		absolute
		color="transparent"
		flat
		height="85"
	>
		<v-container>
			<v-row align="center">
				<img
					src="../../../../../public/logo-tr.png"
					alt="title"
					width="96"
					@click="home"
					class="cursor-pointer"
				/>

				<v-spacer />

				<v-btn
					v-for="(item, i) in items"
					:key="i"
					:to="item.to"
					class="hidden-sm-and-down"
					min-height="48"
					text
				>
					<v-icon
						left
						size="20"
						v-text="item.icon"
					/>

					<span v-text="item.text" />
				</v-btn>
			</v-row>
		</v-container>
	</v-app-bar>
</template>

<script>
	export default {
		name: "PagesCoreAppBar",

		data: () => ({
			items: [
				{
					icon: "mdi-account-multiple-plus",
					text: "Регистрация",
					to: "/pages/register"
				},
				{
					icon: "mdi-fingerprint",
					text: "Вход",
					to: "/pages/login"
				}
			]
			// titles: {
			// 	"/pages/login": "Login Page",
			// 	"/pages/register": "",
			// 	"/pages/recovery": ""
			// }
		}),

		// computed: {
		// 	title() {
		// 		return this.titles[this.$route.path];
		// 	}
		// },
		methods: {
			home() {
				this.$router.push("/");
			}
		}
	};
</script>

<style>
	.cursor-pointer {
		cursor: pointer;
	}
</style>